import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdatePicture() {
  const { t } = useTranslation(['account', 'exceptions'])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  const { authInfo } = useAuth()
  const { putter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updatePicture = async (picture: File) => {
    setLoading(true)
    setError(null)
    setSuccess(null)

    try {
      const formData = new FormData()

      formData.append('picture', picture)

      await putter(`${CONFIG.BOUNCE_API}/api/v1/profile/picture`, formData)
      setSuccess(t('account:account.hook.picture.saved'))
      return true
    } catch (error) {
      console.error(error)

      if (error instanceof ApiError) {
        setError(getErrorMessage(error.data))
      } else {
        setError(t('exceptions:unknown'))
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    updatePicture,
    loading,
    error,
    success,
    resetState,
  }
}
